import { __decorate, __metadata } from "tslib";
import { formatHex } from '@1inch-community/core/formatters';
import '@1inch-community/ui-components/loaders';
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { tooltip } from '../tooltip';
let AddressViewElement = class AddressViewElement extends LitElement {
    constructor() {
        super(...arguments);
        this.hideTooltip = false;
    }
    static { this.tagName = 'inch-address-view'; }
    render() {
        if (!this.address) {
            return html `<inch-loader-skeleton></inch-loader-skeleton>`;
        }
        const formatedAddress = formatHex(this.address, this.formatParams);
        if (this.hideTooltip) {
            return html `<span>${formatedAddress}</span>`;
        }
        return html `<span ${tooltip(this.address)}>${formatedAddress}</span>`;
    }
};
__decorate([
    property({ type: String, attribute: true }),
    __metadata("design:type", String)
], AddressViewElement.prototype, "address", void 0);
__decorate([
    property({ type: Boolean, attribute: true }),
    __metadata("design:type", Boolean)
], AddressViewElement.prototype, "hideTooltip", void 0);
__decorate([
    property({ type: Object, attribute: false }),
    __metadata("design:type", Object)
], AddressViewElement.prototype, "formatParams", void 0);
AddressViewElement = __decorate([
    customElement(AddressViewElement.tagName)
], AddressViewElement);
export { AddressViewElement };
//# sourceMappingURL=address-view.element.js.map